module.exports = __webpack_public_path__ + "static/media/icn_service_ratings.3a4cf0d9.svg";